"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var react_1 = require("react");
/**
 * A ResponsiveHelper component is a utility component used to assist in responsive behavior changes for a host component.
 */
var ResponsiveHelper = /** @class */ (function (_super) {
    __extends(ResponsiveHelper, _super);
    function ResponsiveHelper(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function (width, height) {
            var _a = _this.props, onChange = _a.onChange, handleHeight = _a.handleHeight, activeBreakPoints = _a.activeBreakPoints, onBreakpoint = _a.onBreakpoint;
            if (onChange) {
                if (handleHeight) {
                    onChange(width, height);
                }
                else {
                    onChange(width);
                }
            }
            if (onBreakpoint || activeBreakPoints) {
                _this.checkBreakPoint(width);
            }
            if (activeBreakPoints) {
                _this.setActiveBreakPoints(width);
            }
        };
        _this.checkBreakPoint = function (width) {
            var currentPoint = _this.state.currentPoint;
            var onBreakpoint = _this.props.onBreakpoint;
            var testPoint;
            if (width < _this.bp['media-s'].width) {
                testPoint = 'media-xs';
            }
            else if (width >= _this.bp['media-s'].width && width < _this.bp['media-m'].width) {
                testPoint = 'media-s';
            }
            else if (width >= _this.bp['media-m'].width && width < _this.bp['media-l'].width) {
                testPoint = 'media-m';
            }
            else if (width >= _this.bp['media-l'].width && width < _this.bp['media-xl'].width) {
                testPoint = 'media-l';
            }
            else {
                testPoint = 'media-xl';
            }
            if (currentPoint !== testPoint) {
                _this.setState({ currentPoint: testPoint });
                return onBreakpoint && onBreakpoint(__assign({ name: testPoint }, _this.bp[testPoint]), width);
            }
        };
        _this.setActiveBreakPoints = function (width) {
            var currentPoint = _this.state.currentPoint;
            var activeBreakPoints = _this.props.activeBreakPoints;
            var points = { xs: false, s: false, m: false, l: false, xl: false };
            var data;
            if (width < _this.bp['media-xs'].width) {
                points.xs = true;
            }
            else if (width > _this.bp['media-xl'].width) {
                points = { xs: true, s: true, m: true, l: true, xl: true };
            }
            else {
                var pointsArray = Object.keys(points);
                if (currentPoint) {
                    var pointIndex = _this.bp[currentPoint].index;
                    data = pointsArray.slice(0, pointIndex + 1);
                }
                else {
                    data = pointsArray;
                }
                for (var index = 0; index < data.length; index++) {
                    var key = data[index];
                    if (_this.bp["media-" + key] && _this.bp["media-" + key].width <= width) {
                        points[key] = true;
                    }
                }
            }
            return activeBreakPoints && activeBreakPoints(points);
        };
        _this.bp = {
            'media-xs': { width: 576, index: 0 },
            'media-s': { width: 768, index: 1 },
            'media-m': { width: 992, index: 2 },
            'media-l': { width: 1200, index: 3 },
            'media-xl': { width: 1600, index: 4 }
        };
        _this.state = {};
        return _this;
    }
    ResponsiveHelper.prototype.render = function () {
        var _a = this.props, refreshRate = _a.refreshRate, activeBreakPoints = _a.activeBreakPoints, onBreakpoint = _a.onBreakpoint, onChange = _a.onChange, rest = __rest(_a, ["refreshRate", "activeBreakPoints", "onBreakpoint", "onChange"]);
        return (React.createElement(react_resize_detector_1.default, __assign({ refreshRate: refreshRate, refreshMode: "throttle", handleWidth: true, onResize: this.onResize }, rest)));
    };
    ResponsiveHelper.defaultProps = {
        refreshRate: 500,
        handleHeight: false
    };
    return ResponsiveHelper;
}(react_1.Component));
exports.default = ResponsiveHelper;
